import { render, staticRenderFns } from "./spore.vue?vue&type=template&id=b0de53c2"
import script from "./spore.vue?vue&type=script&lang=js"
export * from "./spore.vue?vue&type=script&lang=js"
import style0 from "./spore.vue?vue&type=style&index=0&id=b0de53c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports